import PageTitle from 'components/common/PageTitle';
import React, { Component } from 'react';
import { connect } from 'react-redux';

class Descuentos extends Component {

    render() {

        return (
            <div>
                <PageTitle 
                    title="sidebar.datosmaestros.descuentos"
                    className="plr-15"
                    breadCrumb={[
                    {
                        name: "sidebar.datosmaestros"
                    },
                    {
                        name: "sidebar.datosmaestros.descuentos"
                    }
                    ]}
                />

                <div className="plr-15">
                    <div className="mtb-30 theme-color">
                        <div className="mtb-10">
                             Herramientas para manejo masivo de descuentos.
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.themeChanger
    };
}

export default connect(mapStateToProps, null)(Descuentos);